import React, { useState, useEffect } from "react";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faStar as faStarFull,
  faStar as faStarEmpty,
  faUserCircle,
} from "@fortawesome/free-solid-svg-icons";
import { BASE_URL, IMAGE_URL } from "../Component/Baseurl";
import defaultfullbanner from "../Component/img/event1.jfif";
import { useNavigate } from "react-router-dom";

const RatingComp = ({ eventUniqueId }) => {
  const [rating, setRating] = useState(0);
  const [review, setReview] = useState("");
  const [visitorId, setVisitorId] = useState(
    localStorage.getItem("visitor_id")
  );
  const [reviews, setReviews] = useState([]);
  const [notification, setNotification] = useState(""); // Add notification state
  const navigate = useNavigate();

  const handleRatingClick = (value) => {
    setRating(value);
  };

  const handleReviewChange = (e) => {
    setReview(e.target.value);
  };

  const showNotification = (message) => {
    setNotification(message);
    setTimeout(() => setNotification(""), 3000); // Hide after 3 seconds
  };

  const handleSubmit = async () => {
    try {
      const response = await axios.post(`${BASE_URL}give_rating`, {
        user_id: visitorId,
        event_unique_id: eventUniqueId,
        rating: rating,
        review_text: review,
      });

      if (response.data) {
        setRating(0);
        setReview("");
        showNotification("Review submitted successfully!");
        fetchReviews(); // Fetch reviews after successful submission
      }
    } catch (error) {
      if (error.response && error.response.status === 409) {
        showNotification("Already Rated this event");
      } else {
        console.error("Error submitting review:", error);
      }
    }
  };

  const handleTextareaClick = () => {
    if (!visitorId) {
      const currentUrl = `${window.location.href}#review`;
      localStorage.setItem("redirectUrl", currentUrl);
      navigate("/login");
    }
  };

  const fetchReviews = async () => {
    try {
      const response = await axios.get(`${BASE_URL}ratings/${eventUniqueId}`);
      if (response.data && response.data.reviews) {
        setReviews(response.data.reviews);
      }
    } catch (error) {
      console.error("Error fetching reviews:", error);
    }
  };

  useEffect(() => {
    fetchReviews();
  }, [eventUniqueId]);

  const sortedReviews = () => {
    const highRatings = reviews.filter((review) => review.rating >= 4);
    const lowRatings = reviews.filter((review) => review.rating < 4);
    return [...highRatings, ...lowRatings].slice(0, 15);
  };

  return (
    <>
      {/* Notification */}
      {notification && <div className="notification">{notification}</div>}

      {/* Rating & Review Modal */}
      <div
        className="modal fade"
        id="ratingModal"
        tabIndex="-1"
        aria-labelledby="ratingModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="ratingModalLabel">
                Give Rating & Write Review
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="mb-3">
                {[...Array(5)].map((_, index) => (
                  <span
                    key={index}
                    onClick={() => handleRatingClick(index + 1)}
                    style={{
                      cursor: "pointer",
                      padding: "0px 4px",
                      fontSize: "25px",
                      color: index < rating ? "#ffc107" : "#e4e5e9",
                    }}
                  >
                    ★
                  </span>
                ))}
              </div>
              <textarea
                className="form-control"
                placeholder="Write Review Here..."
                required
                value={review}
                onChange={handleReviewChange}
                rows="4"
                style={{ resize: "none", width: "100%" }}
              />
            </div>
            <div className="modal-footer">
              {visitorId && (
                <button
                  className="btnn bg-gradient-primary text-white"
                  onClick={handleSubmit}
                  data-bs-dismiss="modal"
                >
                  Submit Review
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Display User Reviews */}
      <div className="eventcard_container bg-salt mb-3 p-2 bdrds mt-3">
        <div className="text-end">
          {visitorId ? (
            // Button to open the modal if visitorId is present
            <div
              type="button"
              className="btn bg-gradient-primary text-white"
              data-bs-toggle="modal"
              data-bs-target="#ratingModal"
              onClick={handleTextareaClick}
            >
              Give Rating & Write Review
            </div>
          ) : (
            // Button to redirect to the login page if visitorId is not present
            <div
              type="button"
              className="btn bg-gradient-primary text-white"
              onClick={() => navigate("/login")}
            >
              Login to Write Review
            </div>
          )}
        </div>

        <div className="head-label py-2  text-start">
          <h2 className="h3clsss text-start mb-2">User Reviews</h2>
          {sortedReviews().length > 0 ? (
            sortedReviews().map((review) => (
              <div className="row mb-2 " key={review.id}>
                <div className="">
                  <div className="d-flex align-items-center">
                    <span>
                      <FontAwesomeIcon
                        icon={faUserCircle}
                        className="text-muted ft11"
                      />
                    </span>
                    <span className="mx-2">
                      <strong>{review.name}</strong>
                    </span>
                  </div>

                  <div>
                    <div className="badge bg-gradient-info">
                      {[...Array(5)].map((_, index) => (
                        <FontAwesomeIcon
                          key={index}
                          icon={
                            review.rating && index < review.rating
                              ? faStarFull
                              : faStarEmpty
                          }
                          className={
                            review.rating && index < review.rating
                              ? "filled-star"
                              : "empty-star"
                          }
                        />
                      ))}
                    </div>

                    <span className="ftratss text-muted mx-2">
                      {new Date(review.created_at).toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                      })}
                    </span>
                  </div>
                  <div className="ftratss1 ">{review.review_text}</div><hr/>
                </div>
                
              </div>
            ))
          ) : (
            <div>No reviews available for this event.</div>
          )}
        </div>
      </div>
    </>
  );
};

export default RatingComp;
